import { isApiError } from '../../api';

/** O que dizer quando não há Lead ou o Bitrix não respondeu (`errorCode` estável vindo do servidor). */
export function bitrixNoticeText(state: 'none' | 'error', errorCode: string | null): string {
  switch (errorCode) {
    case 'no_assignee':
      return 'Este cliente não tem Lead ativo no Bitrix e nenhum responsável foi escolhido para os Leads novos. Um administrador escolhe em Administração, Bitrix.';
    case 'native_pending':
      return 'O Bitrix ainda não criou o Lead deste cliente. Ele cria quando a conversa chega à linha aberta; se não aparecer, confira a linha em Administração, Bitrix.';
    case 'no_phone':
      return 'Esta conversa não tem um telefone para procurar no Bitrix.';
    case 'unavailable':
      return 'O Bitrix não respondeu depois de várias tentativas. Tente de novo.';
    case 'auth':
      return 'O acesso do CladvApp ao Bitrix precisa ser refeito. Um administrador resolve em Administração, Bitrix.';
    case 'rejected':
      return 'O Bitrix recusou criar o Lead. Um administrador pode conferir as opções em Administração, Bitrix.';
    case 'internal_error':
      return 'Aconteceu um erro inesperado ao conferir o Bitrix. Tente de novo.';
    default:
      return state === 'error'
        ? 'Não foi possível conferir o Bitrix. Tente de novo.'
        : 'Esta conversa ainda não foi conferida no Bitrix.';
  }
}

/** Texto para quando o pedido de "verificar de novo" falha. */
export function bitrixSyncErrorText(error: unknown): string {
  if (isApiError(error)) {
    if (error.code === 'not_assigned') {
      return 'Você não é mais o responsável por esta conversa.';
    }
    if (error.code === 'not_connected') return 'A integração com o Bitrix não está ligada.';
    if (error.status === 0 || error.status >= 500) {
      return 'Não foi possível pedir a conferência agora. Tente de novo em instantes.';
    }
  }
  return 'Não foi possível pedir a conferência. Tente de novo.';
}
